/*
*   Данные и логика по калькулятору стоимости/сроков
*/
import ajaxRequest from '@/utils/request';

const state = {
    calculatorDeliveries: [],

    calculatorParams: {
        price_to_pay: null,
        price_insurance: null,
        weight: null,
        x: null,
        y: null,
        z: null
    }
};

let isParamsChanged = (state_, params) => {
    for (let key in state_.calculatorParams) {
        if (state_.calculatorParams[key] !== params[key]) return true;
    }
    return false;
};

const getters = {
    calculatorParams: state => state.calculatorParams,
    calculatorDeliveries: state => state.calculatorDeliveries
};

const actions = {
    calculateDelivery(context, params) {
        return new Promise((resolve, reject) => {
            ajaxRequest({
                url: '/widget/calculate/',
                params,
                success(response) {
                    context.commit('calculateDelivery', {
                        resolve,
                        data: response.data
                    });
                },
                failure({error}) {
                    reject(error);
                }
            });
        });
    },
    loadCalculatorParams(context, params) {
        return new Promise((resolve, reject) => {
            ajaxRequest({
                url: '/shops/calculator_params/get/',
                success(response) {
                    context.commit('saveCalculatorParams', {
                        resolve,
                        data: response.data
                    });
                }
            });
        });
    },
    saveCalculatorParams(context, params) {
        return new Promise((resolve, reject) => {
            if (isParamsChanged(context.state, params)) {
                ajaxRequest({url: '/shops/calculator_params/save/',
                    method: 'POST',
                    params,
                    success(response) {
                        context.commit('saveCalculatorParams', {
                            resolve,
                            data: response.data
                        });
                    }
                });
            }
        });
    }
};

const mutations = {
    calculateDelivery(state, {resolve, data}) {
        state.calculatorDeliveries = data;

        resolve();
    },
    saveCalculatorParams(state, {resolve, data}) {
        state.calculatorParams = data;

        resolve();
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/calculator.js